import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=1a7c0cc7&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=1a7c0cc7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c0cc7",
  null
  
)

export default component.exports